// extracted by mini-css-extract-plugin
export default {"listItems":"Sidebar_listItems__2sqJy","lastItem":"Sidebar_lastItem__WFR5K"};